import {useEffect, useState} from "react";
import staticVariable from "./staticVariable";

const PeriodControlMobile = ({ menuDisplayToggle, showVicennialAreaMean, getParamElement, climateData, setClearMouseModeAction, earthController, tbodyRef, unitToggle, getOverlayClassName, overlayUnit,
                                 colorGradientList, showVicennialLocationAverage, handleClickDownload, primaryUnit, handleClickNani, periodPlay, periodValue, handleChangePeriodSlide, overlayType, mouseMode }) => {
    const [mobileClimateData, setMobileClimateData] = useState(climateData);

    useEffect(() => {
        if (climateData) {
            //모바일은 20년 단위가 아니라 40년단위로 평균 데이터를 보여준다.
            //따라서 api로 가져온 20년단위 데이터를 40년 단위 데이터로 변경하여 사용하기 위한 코드이다.
            if (mouseMode !== 'crossSection') {
                const fortyYearsClimateData = {header: climateData.header, data: []};
                for (let i = 0; i < climateData.data.length; i += 2) {
                    const fortyYearsData = {
                        date: climateData.data[i].date,
                        primary: climateData.data[i].primary ? {
                            field: climateData.data[i].primary.field,
                            interpolates: [climateData.data[i].primary.interpolates[0], climateData.data[i].primary.interpolates[1], (climateData.data[i].primary.interpolates[2] + climateData.data[i + 1].primary.interpolates[2]) / 2],
                            type: climateData.data[i].primary.type,
                        } : null,
                        overlay: {
                            field: climateData.data[i].overlay.field,
                            interpolates: climateData.data[i].overlay.interpolates ? (climateData.data[i].overlay.interpolates + climateData.data[i + 1].overlay.interpolates) / 2 : climateData.data[i].overlay.interpolates,
                            type: climateData.data[i].overlay.type,
                        },
                    };
                    fortyYearsClimateData.data.push(fortyYearsData);
                }
                setMobileClimateData(fortyYearsClimateData);
            } //if (mouseMode !== 'crossSection') { end
        } //if (climateData) { end
    }, [climateData])

    return <div className="btm01" style={menuDisplayToggle === true ? null : {display: 'none'}}>
        <div className="color_pick">
            <div className="sq02">
                <div className="sq02_in">
                    <a href="javascript:;">
                        <canvas id="scale"></canvas>
                        <div id={'scale_label'} className="w1" style={{display:'none'}}></div>
                    </a>
                </div>
            </div>
        </div>
        <div className="btm01_in">
            {/*영역평균*/}
            <div className={showVicennialAreaMean ? "btm01_a btmd_a on" : "btm01_a btmd_a"}>
                <div className="vrt_close01" onClick={() => {
                    setClearMouseModeAction(true);
                    earthController.clearLocationDetailsAreaMean(true);
                }}>
                    <a href="javascript:;" className="btn_vrt_close01"><span className="blind">닫기</span></a>
                </div>
                <div className="btma_lt01">
                    {getParamElement('areaMean')}
                    <div className="st01">
                        <div className="st01_w1 cl">
                            <h3>위치<br/>정보</h3>
                        </div>
                        <div className="e1">
                            <ul className="cl">
                                <li>{showVicennialAreaMean && mobileClimateData ? `${Math.abs(Number(mobileClimateData.header.coord[0][1]).toFixed(2))}${Number(mobileClimateData.header.coord[0][1]) > 0 ? 'N' : 'S'},
                                ${Math.abs(Number(mobileClimateData.header.coord[0][0]).toFixed(2))}${Number(mobileClimateData.header.coord[0][0]) > 0 ? 'E' : 'W'}` : ''}</li>
                                <li>{showVicennialAreaMean && mobileClimateData ? `${Math.abs(Number(mobileClimateData.header.coord[1][1]).toFixed(2))}${Number(mobileClimateData.header.coord[1][1]) > 0 ? 'N' : 'S'},
                                ${Math.abs(Number(mobileClimateData.header.coord[1][0]).toFixed(2))}${Number(mobileClimateData.header.coord[1][0]) > 0 ? 'E' : 'W'}` : ''}</li>
                                <li>{showVicennialAreaMean && mobileClimateData ? `${Math.abs(Number(mobileClimateData.header.coord[2][1]).toFixed(2))}${Number(mobileClimateData.header.coord[2][1]) > 0 ? 'N' : 'S'},
                                ${Math.abs(Number(mobileClimateData.header.coord[2][0]).toFixed(2))}${Number(mobileClimateData.header.coord[2][0]) > 0 ? 'E' : 'W'}` : ''}</li>
                                <li>{showVicennialAreaMean && mobileClimateData ? `${Math.abs(Number(mobileClimateData.header.coord[3][1]).toFixed(2))}${Number(mobileClimateData.header.coord[3][1]) > 0 ? 'N' : 'S'},
                                ${Math.abs(Number(mobileClimateData.header.coord[3][0]).toFixed(2))}${Number(mobileClimateData.header.coord[3][0]) > 0 ? 'E' : 'W'}` : ''}</li>
                            </ul>

                        </div>
                    </div>
                </div>
                <div className="btma_lt02_wrap">
                    <div className="btma_lt02">
                        <div className="btma_lt02_con">
                            <div className="btma_lt02_in">
                                <a href={"javascript:;"} title={'단위변경'} onClick={() => unitToggle(overlayType, 'areaMean')}><p className={"w1 " + getOverlayClassName()}>{overlayUnit.label}</p></a>
                            </div>
                        </div>
                    </div>
                    <div className="btma_lt03">
                        <svg id="overlay-chart" className="overlay-chart" xmlns="http://www.w3.org/2000/svg"
                             version="1.1" style={{height: '60px'}}></svg>
                        <table>
                            <tbody ref={tbodyRef}>
                            {showVicennialAreaMean && mobileClimateData ?
                                <tr>
                                    {mobileClimateData.data.map((vicennialData, i) =>
                                        vicennialData.overlay.interpolates !== null ? <td colSpan="2" style={{color: 'rgba(' + colorGradientList[i][0] + "," + colorGradientList[i][1] + "," + colorGradientList[i][2] + "," + colorGradientList[i][3] + ')',
                                                                textShadow: '-0.4px 0px rgb(255, 255, 255), 0px 0.4px rgb(255, 255, 255), 0px -0.4px rgb(255, 255, 255)'}}
                                            className="w1">{overlayUnit.conversion(vicennialData.overlay.interpolates).toFixed(overlayUnit.precision)}</td>
                                            : <td colSpan="2" className="w1">n/a</td>)}
                                </tr> : ''

                            }
                            {showVicennialAreaMean && mobileClimateData ?
                                <tr>
                                    {mobileClimateData.data.map((vicennialData) =>
                                        <td colSpan="2"></td>)}
                                </tr> : ''

                            }
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
            {/*기본*/}
            <div className={showVicennialLocationAverage === true ? "btm01_a tp02 btmd_b on" : "btm01_a tp02 btmd_b"}>
                <div className="vrt_close01" onClick={() => {
                    setClearMouseModeAction(true);
                    earthController.clearAvgAnnualLocationDetails(true);
                }}>
                    <a href="javascript:;" className="btn_vrt_close01"><span className="blind">닫기</span></a>
                </div>
                <div className="btma_lt01">
                    {getParamElement('basic')}
                    <div className="st01">
                        <div className="st01_w1 cl">
                            <h3>위치 정보</h3>
                            <p className="p01">{showVicennialLocationAverage && mobileClimateData ? `${Math.abs(Number(mobileClimateData.header.coord[1]).toFixed(2))}${Number(mobileClimateData.header.coord[1]) > 0 ? 'N' : 'S'}, 
                        ${Math.abs(Number(mobileClimateData.header.coord[0]).toFixed(2))}${Number(mobileClimateData.header.coord[0]) > 0 ? 'E' : 'W'}`: ''}</p>
                            <a href="javascript:;" className="btn_down01" onClick={handleClickDownload}><span className="blind">다운로드</span></a>
                        </div>
                    </div>
                </div>
                <div className="btma_lt02_wrap">
                    <div className="btma_lt02">
                        <div className="btma_lt02_con" style={!(overlayType === 'wind' || overlayType === 'currents') ? { height: '50%' } : { height: '100%' }}>
                            <div className="btma_lt02_in">
                                <a href={"javascript:;"} title={'단위변경'} onClick={() => unitToggle('wind')}><p className={"w1 " + getOverlayClassName(true)}>{primaryUnit.label}</p></a>
                            </div>
                        </div>
                        <div className="btma_lt02_con" style={{ height: '50%' }}>
                            <div className="btma_lt02_in">
                                <a href={"javascript:;"} title={'단위변경'} onClick={() => unitToggle(overlayType)}><p className={"w1 " + getOverlayClassName()}>{overlayUnit.label}</p></a>
                            </div>
                        </div>
                    </div>
                    <div className="btma_lt03">
                        <table>
                            <tbody>
                            {showVicennialLocationAverage && climateData ?
                                <tr>
                                    {mobileClimateData.data.map((fortyYearData, i) =>
                                        <td colSpan="2"
                                            style={
                                                (climateData.data[0].overlay.type === 'wind' || climateData.data[0].overlay.type === 'currents') ?
                                                    {
                                                        color: 'rgba(' + colorGradientList[i][0] + "," + colorGradientList[i][1] + "," + colorGradientList[i][2] + "," + colorGradientList[i][3] + ')',
                                                        textShadow: '-0.4px 0px rgb(255, 255, 255), 0px 0.4px rgb(255, 255, 255), 0px -0.4px rgb(255, 255, 255)'
                                                    } : {}
                                            }
                                            className="w1">{primaryUnit.conversion(fortyYearData.primary.interpolates[2]).toFixed(primaryUnit.precision)}</td>)}
                                </tr> : ''
                            }
                            {showVicennialLocationAverage && mobileClimateData && !(mobileClimateData.data[0].overlay.type === 'wind' || mobileClimateData.data[0].overlay.type === 'currents')?
                                <tr>
                                    {mobileClimateData.data.map((fortyYearData, i) =>
                                        fortyYearData.overlay.interpolates !== null ? <td colSpan="2" style={{color: 'rgba(' + colorGradientList[i][0] + "," + colorGradientList[i][1] + "," + colorGradientList[i][2] + "," + colorGradientList[i][3] + ')',
                                                                textShadow: '-0.4px 0px rgb(255, 255, 255), 0px 0.4px rgb(255, 255, 255), 0px -0.4px rgb(255, 255, 255)'}}
                                            className="w2">{overlayUnit.conversion(fortyYearData.overlay.interpolates).toFixed(overlayUnit.precision)}</td>
                                            : <td colSpan="2" className="w1">n/a</td>)}
                                </tr> : ''
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="btm01_b">
                <div className="btm_rt01_wrap">
                    <a href="javascript:;" onClick={handleClickNani("nani-now")}>
                    <div className="btm_rt01">
                        <p className="w1">year</p>
                    </div>
                    </a>
                    <div className="btm_rt02">
                        <div className="slider_mark01">
                            <ul>
                                <li><span>1850</span></li>
                                <li><span>1900</span></li>
                                <li><span>1940</span></li>
                                <li><span>1980</span></li>
                                <li><span>2020</span></li>
                                <li><span>2060</span></li>
                                <li><span>2100</span></li>
                            </ul>
                        </div>
                        <div id="slider" className="slider">
                            {/*<output className="slider-output">50</output>*/}
                            <div className="slider-track">
                                <div className="slider-thumb" style={{left:periodValue / staticVariable.PERIOD_MAX * 100 + '%'}}></div>
                                <div className="slider-level" style={{width:periodValue / staticVariable.PERIOD_MAX * 100 + '%'}}></div>
                            </div>
                            <input className="slider-input" type="range" value={periodValue} step={1} min={0} max={staticVariable.PERIOD_MAX} onChange={handleChangePeriodSlide}/>
                        </div>
                        <div className="btm_rt02b">
                            <div className="w1">
                                <div id="data-date" className="e1 local"></div>
                                <div className="e2">
                                    <a href="javascript:;" onClick={() => earthController.timeBoxUpdate(true)}><span className="blind">선택</span></a>
                                </div>
                                <div id="toggle-zone" className="e3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="btm_lt01">
                    <a href="javascript:;" className="btm_btn01" onClick={handleClickNani("nani-backward-most")} title={'-20year'}>-20y</a>
                    <a href="javascript:;" className="btm_btn01" onClick={handleClickNani("nani-backward-more")}>-1y</a>
                    <a href="javascript:;" className="btm_btn01" onClick={handleClickNani("nani-backward")}>-1m</a>
                    <a href="javascript:;" className={"btm_btn02 " + (periodPlay ? "on" : "")} onClick={handleClickNani("nani")}><span className="blind">play</span></a>
                    <a href="javascript:;" className="btm_btn01" onClick={handleClickNani("nani-forward")}>+1m</a>
                    <a href="javascript:;" className="btm_btn01" onClick={handleClickNani("nani-forward-more")}>+1y</a>
                    <a href="javascript:;" className="btm_btn01" onClick={handleClickNani("nani-forward-most")}>+20y</a>
                </div>

            </div>
        </div>
    </div>
}

export default PeriodControlMobile;